import React from 'react';
import HeaderSeven from '../../components/Header/HeaderSeven';
import HeaderFive from '../../components/Header/HeaderFive';
import ServiceMain from './ServiceMain';
import Footer from '../../components/Footer';
import FooterThree from '../../components/Footer/FooterThree';

const Service = () => {
  return (
    <>
      <HeaderFive />

      <ServiceMain />

      <FooterThree />
    </>
  );
};

export default Service;
